import { LineString, Point, Polygon } from "vue-niney";

export function SVGConverter() { }

SVGConverter.prototype.vectorTileFeatureToPoint = function(feature) {
  const points = [];

  let pathX = 0;
  let pathY = 0;

  const pbf = feature._pbf;
  pbf.pos = feature._geometry;

  const end = pbf.readVarint() + pbf.pos;
  while (pbf.pos < end) {
    const cmdLen = pbf.readVarint();
    const cmd = cmdLen & 0x7;
    const length = cmdLen >> 3;

    for (let i = 0; i < length; i++) {
      if (cmd === 1) {  // MoveTo
        pathX += pbf.readSVarint();
        pathY += pbf.readSVarint();
        points.push(new Point(pathX, pathY));
      } else {
        throw new Error("Not a point command: " + cmd);
      }
    }
  }

  if (points.length == 0) {
    throw new Error("No point found.");
  }
  if (points.length > 1) {
    throw new Error("Multi-points not yet supported.");
  }
  return points[0];
}

SVGConverter.prototype.vectorTileFeatureToPath = function(feature) {
  let path = "";

  let previousX = 0;
  let previousY = 0;
  let pathX = 0;
  let pathY = 0;
  let lastMoveX = 0;
  let lastMoveY = 0;

  const extent = feature.extent;
  const lineTo = (pathX, pathY) => {
    if (
      ((previousX < 0) && (pathX < 0)) ||
      ((previousX > extent) && (pathX > extent)) ||
      ((previousY < 0) && (pathY < 0)) ||
      ((previousY > extent) && (pathY > extent))
    ) {
      return "K" + pathX + " " + pathY + " ";
    } else {
      return "L" + pathX + " " + pathY + " ";
    }
  }

  const pbf = feature._pbf;
  pbf.pos = feature._geometry;

  const end = pbf.readVarint() + pbf.pos;
  while (pbf.pos < end) {
    const cmdLen = pbf.readVarint();
    const cmd = cmdLen & 0x7;
    const length = cmdLen >> 3;

    for (let i = 0; i < length; i++) {
      previousX = pathX;
      previousY = pathY;
      if (cmd === 1 || cmd === 2) {
        pathX += pbf.readSVarint();
        pathY += pbf.readSVarint();

        if (cmd === 1) {  // MoveTo
          path += "M" + pathX + " " + pathY + " ";
          lastMoveX = pathX;
          lastMoveY = pathY;
        } else {  // LineTo
          path += lineTo(pathX, pathY);
        }
      } else if (cmd === 7) {  // ClosePath
        path += lineTo(lastMoveX, lastMoveY) + "Z ";
      } else {
        throw new Error("Unknown command: " + cmd);
      }
    }
  }

  return path;
}

SVGConverter.prototype.pathToLineString = function(path) {
  path = path.replace(/[^0-9 ]/g, "");
  const pointStrings = path.split(" ");
  const points = [];
    for (var i = 0; i < pointStrings.length; i = i + 2) {
        var coordStrings = [pointStrings[i], pointStrings[i + 1]];
        points.push(new Point(parseFloat(coordStrings[0]), parseFloat(coordStrings[1])));
    }
    return new LineString(points);
}


SVGConverter.prototype.pathToPolygon = function(path) {
    var lineStrings = [];
        lineStrings.push(this.pathToLineString(path));
    return new Polygon(lineStrings);
}

SVGConverter.prototype.isPointInPath = function(x, y, path, evenOdd = true) {
  const subpaths = path.match(/M[^M]+/gi);
  if (!subpaths) return false;

  const pointInPolygon = (x, y, points) => {
    let inside = false;
    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
      const xi = points[i].x, yi = points[i].y;
      const xj = points[j].x, yj = points[j].y;

      const intersect = ((yi > y) !== (yj > y)) &&
                        (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  };

  let insideCount = 0;

  for (const sub of subpaths) {

    const commands = sub.match(/[MLK][^MLKZ]+/gi);

    const points = commands.map(cmd => {
      const coords = cmd.slice(1).trim().split(/[\s,]+/).map(Number);
      return { x: coords[0], y: coords[1] };
    });

    if (pointInPolygon(x, y, points)) {
      insideCount++;
    }
  }

  return evenOdd ? (insideCount % 2 === 1) : (insideCount > 0);
}
